import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "transaction-password-popup" }

import { ref, inject, onMounted } from 'vue';
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia';
import PopupForm from '@/components/PopupForm.vue';
import CreatePassword from './CreatePassword.vue';
import ResetPassword from './ResetPassword.vue';
import BindMobile from '../BindMobile'
import { useUserStore } from '@/store';


export default {
  __name: 'index',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const MyDialog = inject('myDialog');

const { t } = useI18n()

const userStore = useUserStore()
const { isNullPasswordTrade, phone } = storeToRefs(userStore);
const showBindMobile = ref(false)


onMounted(() => {
  // 未绑定手机号
  if(!isNullPasswordTrade.value && !phone.value) {
    MyDialog.confirm({
      message: t('msg.beforeResetPassword'),
    })
    .then(() => {// on confirm
      showBindMobile.value = true;
    })
    .catch(() => {
      emit('onClose')
    });
  }
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isNullPasswordTrade))
      ? (_openBlock(), _createBlock(CreatePassword, {
          key: 0,
          onOnClose: _cache[0] || (_cache[0] = $event => (emit('onClose')))
        }))
      : (_unref(phone))
        ? (_openBlock(), _createBlock(ResetPassword, {
            key: 1,
            phone: _unref(phone),
            onOnClose: _cache[1] || (_cache[1] = $event => (emit('onClose')))
          }, null, 8, ["phone"]))
        : (!_unref(phone) && showBindMobile.value)
          ? (_openBlock(), _createBlock(PopupForm, {
              key: 2,
              title: _ctx.$t('label.bindMobile'),
              onOnClose: _cache[2] || (_cache[2] = $event => (showBindMobile.value = false, emit('onClose')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BindMobile))
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true)
  ]))
}
}

}